"use client";

import {
  API_ENDPOINTS,
  apiRequest,
  DataReturnType,
  FinanceEligibilityRequestCreateDTO,
  FinanceEligibilityRequestResponseDTO,
} from "@alba-cars/common-modules";

// Main function to get signed URLs
export const createFinanceEligibilityRequest = async (
  data: Omit<FinanceEligibilityRequestCreateDTO, "validate" | "toPlain">,
) => {
  const companyAge = data.isCompanyOlderThanOneYear as unknown as "yes" | "no";

  data.isCompanyOlderThanOneYear = companyAge === "yes";

  const response = await apiRequest<DataReturnType<FinanceEligibilityRequestResponseDTO> & { isEligible: boolean }>(
    API_ENDPOINTS.financeEligibilityRequest.create.toString(),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    },
  );
  return response;
};
